// extracted by mini-css-extract-plugin
module.exports = {"button":"style_button__1C1eh"};